/* eslint-disable react/display-name */
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import s from './index.module.scss';

const Steps = memo(
	props => (
		<div className={s.stepsContent}>
			{props.previousStep && props.stepsList[props.previousStepIndex] && (
				<div
					className={`${s.stepWrapper} ${s.previousStepWrapper}`}
					key={props.stepsList[props.previousStepIndex].name}
				>
					{props.stepsComponentsType[props.stepsList[props.previousStepIndex].name](
						props.stepsList[props.previousStepIndex]
					)}
				</div>
			)}
			<div className={`${s.stepWrapper} ${s.currentStepWrapper}`} key={props.stepsList[props.currentStepIndex].name}>
				{props.stepsComponentsType[props.stepsList[props.currentStepIndex].name](
					props.stepsList[props.currentStepIndex]
				)}
			</div>
			{props.nextStep && props.stepsList[props.nextStepIndex] && (
				<div className={`${s.stepWrapper} ${s.nextStepWrapper}`} key={props.stepsList[props.nextStepIndex].name}>
					{props.stepsComponentsType[props.stepsList[props.nextStepIndex].name](props.stepsList[props.nextStepIndex])}
				</div>
			)}
		</div>
	),
	(prevProps, nextProps) => {
		// TODO: Create separate function
		const forward = prevProps.currentStepIndex < nextProps.currentStepIndex;
		const back = prevProps.currentStepIndex > nextProps.currentStepIndex;

		if (forward && nextProps.previousStepIndex === null) return true;
		if (back && nextProps.nextStepIndex === null) return true;
	}
);

function StepsContent(props) {
	const stepsList = useSelector(state => state.steps.list);
	const previousStep = useSelector(state => state.steps.previousStep);
	const currentStepIndex = useSelector(state => state.steps.currentStepIndex);
	const previousStepIndex = previousStep && currentStepIndex - 1;
	const nextStep = useSelector(state => state.steps.nextStep);
	const nextStepIndex = nextStep && currentStepIndex + 1;

	return (
		(stepsList && (
			<Steps
				stepsList={stepsList}
				previousStep={previousStep}
				currentStepIndex={currentStepIndex}
				previousStepIndex={previousStepIndex}
				nextStep={nextStep}
				nextStepIndex={nextStepIndex}
				stepsComponentsType={props.stepsComponentsType}
			/>
		)) ||
		''
	);
}

export default StepsContent;
